import { render } from "./AdvisoriesView.vue?vue&type=template&id=09053fbb"
import script from "./AdvisoriesView.vue?vue&type=script&lang=js"
export * from "./AdvisoriesView.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__